<template>
  <div>
    <v-app-bar app dark flat>
      <v-container class="pa-0" fluid>
        <v-row no-gutters align="center">

          <v-col cols="12">

            <!-- ===================== DESKTOP HEADER ===================== -->
            <template v-if="!isMobile">
              <v-row no-gutters align="center">
                <v-col cols="3"></v-col>

                <v-col cols="9" class="d-flex align-center">
                  <router-link :to="`/home`">
                    <div class="d-flex align-center mr-10">
                      <img
                          src="../assets/banner-logo-8.png"
                          alt="eduplus logo"
                          class="logo"
                      />
                    </div>
                  </router-link>

                  <v-tabs
                      v-model="activeTab"
                      class="custom-tab"
                      align-tabs="start"
                      hide-slider
                  >
                    <v-tab
                        v-for="(tab, index) in tabs"
                        :key="tab.to"
                        @click="goTo(tab.to, index)"
                    >
                      {{ tab.label }}
                    </v-tab>
                  </v-tabs>
                </v-col>
              </v-row>
            </template>

            <!-- ===================== MOBILE HEADER ===================== -->
            <template v-else>
              <div class="mobile-header">

                <!-- Hamburger button (left) -->
                <v-app-bar-nav-icon
                    class="menu-icon"
                    @click="drawer = !drawer"
                />

                <!-- Centered Logo -->
                <router-link :to="`/home`" class="logo-link mobile-logo-wrapper">
                  <img
                      src="../assets/banner-logo-8.png"
                      alt="eduplus logo"
                      class="logo mobile-logo"
                  />
                </router-link>

              </div>
            </template>

          </v-col>

        </v-row>
      </v-container>
    </v-app-bar>

    <!-- =============== MOBILE DRAWER =============== -->
    <v-navigation-drawer
        v-if="isMobile"
        v-model="drawer"
        app
        temporary
    >
      <v-list density="compact">

        <v-list-item>
          <v-list-item-title class="drawer-title">
            메뉴
          </v-list-item-title>
        </v-list-item>

        <v-divider />

        <v-list-item
            v-for="(tab, index) in tabs"
            :key="tab.to"
            :class="{ 'drawer-item-active': activeTab === index }"
            @click="goTo(tab.to, index, true)"
        >
          <v-list-item-title>{{ tab.label }}</v-list-item-title>
        </v-list-item>

      </v-list>
    </v-navigation-drawer>
  </div>
</template>


<script>
export default {
  name: "WebHeader",

  data() {
    return {
      activeTab: 0,
      drawer: false,
      isMobile: false,
      tabs: [
        { label: "유학원소개", to: "/business" },
        { label: "어학원",   to: "/language" },
        { label: "대학교",   to: "/university" },
        { label: "상담신청", to: "/consult" },
      ],
    };
  },

  created() {
    this.checkIsMobile();
    window.addEventListener("resize", this.checkIsMobile);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.checkIsMobile);
  },

  watch: {
    "$route.path": {
      immediate: true,
      handler(newPath) {
        const idx = this.tabs.findIndex(t => t.to === newPath);
        if (idx !== -1) this.activeTab = idx;
      },
    },
  },

  methods: {
    checkIsMobile() {
      // breakpoint for mobile mode (same as Vuetify md)
      this.isMobile = window.innerWidth < 960;
    },

    goTo(path, index, fromDrawer = false) {
      this.activeTab = index;
      if (fromDrawer) this.drawer = false;
      if (this.$route.path !== path) this.$router.push(path);
    },
  },
};
</script>


<style scoped>
/* ========== SHARED LOGO STYLES ========== */
.logo {
  width: 200px;
  height: auto;
}

.logo-link {
  text-decoration: none;
}

/* ========== DESKTOP TAB STYLES ========== */
.custom-tab :deep(.v-tab .v-btn__content),
.custom-tab :deep(.v-tab .v-tab__content) {
  font-size: 16px !important;
}

.custom-tab :deep(.v-tab--selected .v-btn__content),
.custom-tab :deep(.v-tab--selected .v-tab__content) {
  color: #0e7700 !important;
  font-weight: 600;
}

.custom-tab :deep(.v-tab:hover) {
  color: #0e7700 !important;
  background-color: transparent !important;
}

/* ========== MOBILE HEADER ========== */
.mobile-header {
  position: relative;
  height: 56px;
  display: flex;
  align-items: center;
}

/* Hamburger icon fixed to left */
.menu-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
}

/* Center the logo visually */
.mobile-logo-wrapper {
  margin: 0 auto;
}

.mobile-logo {
  display: block;
  margin: 0 auto;
  width: 150px; /* adjust as needed */
}

/* ========== MOBILE DRAWER ========== */
.drawer-title {
  font-weight: 600;
  font-size: 16px;
  padding: 8px 16px;
}

.drawer-item-active {
  background-color: rgba(14, 119, 0, 0.08);
}

.drawer-item-active :deep(.v-list-item-title) {
  color: #0e7700;
  font-weight: 600;
}
</style>
